import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class ProjectedTaskConfigurationService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<ProjectedTaskConfiguration[]> => {
    return this.apiHttp.get<ProjectedTaskConfiguration[]>("projectedtaskconfigurations");
  }

  public search = (query: ProjectedTaskConfigurationQueryModel): Observable<ProjectedTaskConfiguration[]> => {
    return this.apiHttp.post<ProjectedTaskConfiguration[]>("projectedtaskconfigurations/search", query);
  };
}

export interface ProjectedTaskConfiguration {
  id: number;
  taskType: TaskType;
  cropId: number;
  timePerPlant: number;
  averageDateOffset: number;
  isActive: boolean;
  growthStageId?: number;
  growthStageContainerType?: GrowthStageContainerType;
  laboratoryId?: number;
  laboratoryAssayId?: number;
  tissueTypeId?: number;
  preferredDayOfWeek?: DayOfWeek;
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export enum TaskType {
  Unknown = 0,
  IntoPots = 1,
  IntoFlats = 2,
  Sampling = 3,
  Pollination = 4,
  Harvest = 5
}

export enum GrowthStageContainerType {
  Unknown = 0,
  Flat = 1,
  Pot = 2
}

export interface ProjectedTaskConfigurationQueryModel {
  ids?: number[];
  taskTypes?: TaskType[];
  cropIds?: number[];
  growthStageIds?: number[];
  tissueTypeIds?: number[];
  laboratoryIds?: number[];
  laboratoryAssayIds?: number[];
  growthStageContainerTypes?: GrowthStageContainerType[];
  isActive?: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/projected-task-configuration.service.ts